<script>
  import sfu_map from './pgconf_map.png?enhanced&w=567;545;360';
</script>

<svelte:head>
  <title>Venue - PGConf.dev 2026</title>
  <meta
    name="description"
    content="PGConf.dev 2026 will be held at Simon Fraser University’s Harbour Centre campus in downtown Vancouver."
  />
</svelte:head>

<h1>Venue</h1>

<p>
  PGConf.dev 2026 will be held at the Vancouver Campus of Simon Fraser
  University in Vancouver, Canada.
</p>

<p>
  Address: Harbour Centre, 515 West Hastings Street Vancouver, B.C. Canada V6B
  5K3
</p>
<p>
  The Vancouver Campus of Simon Fraser University, is located in the heart of
  downtown Vancouver near Waterfront Station and Gastown.
</p>

<iframe
  title="SFU Downtown"
  width="425"
  height="350"
  src="https://www.openstreetmap.org/export/embed.html?bbox=-123.15562248229982%2C49.26281971048906%2C-123.06850433349611%2C49.30576242115396&amp;layer=mapnik&amp;marker=49.284295740572944%2C-123.11206340789795"
  style="border: 1px solid black; max-width: 100%;"
></iframe>

<br />

<small>
  <a
    href="https://www.openstreetmap.org/?mlat=49.2843&amp;mlon=-123.1121#map=14/49.2843/-123.1121"
    target="_blank"
  >
    View Larger Map
  </a>
</small>

<p>
  Simon Fraser University has multiple campuses in the Vancouver area. The
  conference is being held at the <b>Vancouver</b> campus which is smaller
  downtown near Waterfront station. The conference is <b>not</b> at the main Burnbay
  campus
</p>

<h2>Parking</h2>
<p>
  There are no designated SFU parking facilities at the Vancouver campus, but
  there are many public parking garages in the area. Two of the closest garages
  to Harbour Centre are the Impark garage at 450 West Cordova Street(daily max
  $14 6am-6pm) and the Diamond Parking garage at 443 Seymour Street(daily max
  $26.75 6am-6p,). The Platinum parking lot at 501 Richards Street(daily max $12
  6am-8pm). All of the above have hourly parking available. Rates subject to
  change.
</p>

<h2>Floor plans</h2>

<enhanced:img src={sfu_map} alt="SFU Floor plan" />

<p>
  The conference is being held in the <b>Harbour Center</b> in the following rooms(among
  others)
</p>

<h3 id="fletcher">Fletcher Challenge Canada Theatre</h3>
<p>
  The Fletcher Challenge Canada Theatre is room 1900 is located on the main
  floor.
</p>

<h3 id="segal">Segal Centre(The Commons)</h3>
<p>
  The Segal Centre is rooms 1400-1410 is located on the main floor. Segal will
  be setup as "The Commons" with tables and chairs for eating lunch, socializing
  or working during all 4 days of the conference. Feel free to drop into The
  Commons anytime during the conference. Posters showcasing contributions and
  projects within our community will also be on display in The Commons
</p>

<h3 id="Labatt">Labatt Hall</h3>
<p>The Labatt Hall room 1700 is located on the main floor</p>

<h3 id="Canfor">Canfor</h3>
<p>The Canfor Policy room (1600) is located on the main floor</p>

<h3 id="Xerox">Xerox Conference Room</h3>
<p>
  The Xerox Conference room (1500) will host the In-person commitfest on the
  20'th and 21st
</p>

<h3 id="Lounge">Social Lounge</h3>
At the far end of the concourse, overlooking Vancouver Harbour the Social Lounge is
our peaceful socializing area. Outfitted with puzzles and games and comfortable chairs,
a great place to meet other attendees and enjoy some low pressure relaxation.
